import type { ValidationSchema } from "../validation";
import { IVirtualPrinterSave } from "../..";
import { GQVirtualPrinterSave } from "graphql-sdk";

export const schemaVirtualPrinter: ValidationSchema<GQVirtualPrinterSave> = {
    name: { required: true },
    printerId: { required: true },
};

export const defaultVirtualPrinter: IVirtualPrinterSave = {
    name: "",
    printerId: undefined,
    departments: [],
};
